import type { Performance_Evaluations_Bool_Exp, Sizing_Pumping_Type_Enum } from "gql/api";

export function perfEvalsWhereNotDeleted(): Performance_Evaluations_Bool_Exp {
  return {
    journal_deleted_at: { _is_null: true },
    scenario: {
      journal_deleted_at: { _is_null: true },
      sizing: { journal_deleted_at: { _is_null: true } }
    }
  };
}

export function perfevalsByTextSearch(
  val?: string
): Performance_Evaluations_Bool_Exp {
  if (!val) {
    return {};
  }

  return {
    ...perfevalsByTitle(val)
  };
}

export function perfevalsByWellName(
  val?: string
): Performance_Evaluations_Bool_Exp {
  if (!val) return {};

  return {
    scenario: {
      sizing: {
        well: {
          well_name: {
            _ilike: `%${val}%`
          }
        }
      }
    }
  };
}

export function perfevalsByCustomerName(
  val?: string
): Performance_Evaluations_Bool_Exp {
  if (!val) return {};

  return {
    scenario: {
      sizing: {
        customer: {
          customer_name: {
            _ilike: `%${val}%`
          }
        }
      }
    }
  };
}

export function perfevalsByOwnerIdOrHalIdentifier(
  id?: string,
  halIdentifier?: string
): Performance_Evaluations_Bool_Exp {
  return {
    _or: [
      {
        author: {
          hal_identifier: { _eq: halIdentifier }
        }
      },
      {
        journal_author_id: { _eq: id }
      }
    ]
  };
}

export function perfevalsByTitle(
  title?: string
): Performance_Evaluations_Bool_Exp {
  if (!title) return {};

  return {
    _or: [{ title: { _ilike: `%${title}%` } }]
  };
}

export function perfevalsScenariosSizingsByTitle(
  title?: string
): Performance_Evaluations_Bool_Exp {
  if (!title) return {};

  return {
    _or: [
      { title: { _ilike: `%${title}%` } },
      {
        scenario: {
          sizing: {
            title: { _ilike: `%${title}%` }
          }
        }
      },
      {
        scenario: {
          title: { _ilike: `%${title}%` }
        }
      }
    ]
  };
}

export function perfevalsByDateRange(
  dates?: Date[]
): Performance_Evaluations_Bool_Exp {
  // if undefined or second date not set return empty object
  if (!dates || !dates[1]) return {};

  return {
    _and: [
      { journal_updated_at: { _gte: dates[0] } },
      { journal_updated_at: { _lte: dates[1] } }
    ]
  };
}

export function perfevalsByPumpingType(val?: string): Performance_Evaluations_Bool_Exp {
  if (!val) return {};
  return {
    scenario: {
      pumping_type: { _eq: val as Sizing_Pumping_Type_Enum }
    }
  };
}
